module.exports = __webpack_public_path__ + "static/media/nuvemshop1.aada456b.png";